import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Rx';
import { AuthService } from './auth.service';
import { Role, UserRoles } from '../model/classes/role.class';
import { UserRolesRequest, UsersByRolesResponse, UsersByRoleRequest } from '../model/interfaces/role.interfaces';
import { ActionConfig, SOCRole } from '../model/classes/soc.role.class';

@Injectable()
export class RolesService {
    private roleUrl = 'api/role';
    private socRoleUrl = 'api/socRole';

    constructor(
        private http: Http,
        private sxHttp: SxHttpService,
        private _authService: AuthService) { }

    getRolesByContext(codSistema: string, codNegocio: string): Observable<Role[]> {
        let url: string;
        if ((codNegocio === '*' && codSistema === '*'))
        {
            codNegocio = 'null';
            codSistema = 'null';
        }
            url = `${this.roleUrl}/GetAll/${codSistema}/${codNegocio}`;

            return this.sxHttp
            .get(url)
            .map(response => response.json().data as Role[]);
    }

    getSecurityAttributes(selectedNodes: String[] = null, searchTerm: String = null, newMode: boolean = true, systemCode: string, businessCode: string): Observable<any> {

        if ((systemCode === '*' && businessCode === '*'))
        {
            systemCode = 'null';
            businessCode = 'null';
        }
        const body = {
            selectedNodes: selectedNodes,
            searchTerm: searchTerm,
            newMode: newMode,
            systemCode: systemCode,
            businessCode: businessCode
        };
        if (selectedNodes && searchTerm) {
            return this.sxHttp
            .post(this.roleUrl + '/GetFilteredSecurityAttributes', body)
            .map(response => response.json().data);
        } else {
            return this.sxHttp
            .post(this.roleUrl + `/GetSecurityAttributes`, body)
            .map(response => response.json().data);
        }
    }

    getSecurityAttributesByFolderId(selectedNodes: String[], parentId: number, newMode: boolean = true, isAncestorOfSelectedAttribute: boolean = false, systemCode: string, businessCode: string) {

        if ((systemCode === '*' && businessCode === '*'))
        {
            systemCode = 'null';
            businessCode = 'null';
        }
        const body = {
            selectedNodes: selectedNodes,
            parentId: parentId,
            newMode: newMode,
            parentIsAncestorOfSelectedAttribute: isAncestorOfSelectedAttribute,
            systemCode: systemCode,
            businessCode: businessCode
        };
        return this.sxHttp
            .post(this.roleUrl + '/GetChildSecurityAttributes', body)
            .map(response => response.json().data);
    }

    getRolesByUser(systemCode: string, businessCode: string, userId: string): Promise<UserRoles> {
        if ((systemCode === '*' && businessCode === '*'))
        {
            systemCode = 'null';
            businessCode = 'null';
        }
        const url = `${this.roleUrl}/UserRoles/${systemCode}/${businessCode}/${userId}`;

        return this.sxHttp
            .get(url)
            .map(response => {
                const data = response.json().data;
                const activeDict = {};
                data.activeRoles.forEach(roleCode => activeDict[roleCode] = true);
                return {
                    roles: data.roles,
                    adminUserName: data.adminUser,
                    activeRoles: activeDict
                } as UserRoles;
            })
            .toPromise();
    }

    updateUserRoles(systemCode: string, businessCode: string, req: UserRolesRequest): Promise<any> {
        if ((systemCode === '*' && businessCode === '*'))
        {
            systemCode = 'null';
            businessCode = 'null';
        }
        const url = `${this.roleUrl}/UserRoles/${systemCode}/${businessCode}`;

        return this.sxHttp
            .post(url, req)
            .map(response => response.json().data)
            .toPromise();

    }

    createRole(role: Role, adminUser: String, secAttrKeys: any): Observable<any> {

        const body = {
            role: role,
            adminUser: adminUser,
            secAttrKeys: secAttrKeys
        };

        return this.sxHttp
            .post(this.roleUrl + '/', body)
            .map(response => response.json());
    }

    getRoleByCode(systemCode: String, businessCode: String, roleCode: String): Observable<Role> {
        if ((systemCode === '*' && businessCode === '*'))
        {
            systemCode = 'null';
            businessCode = 'null';
        }
        return this.sxHttp
            .get(`${this.roleUrl}/Get/${systemCode}/${businessCode}/${roleCode}`)
            .map(response => response.json().data as Role);
    }

    updateRole(role: Role, adminUser: String, secAttrKeys: any, uncheckedAncestors: any): Observable<any> {
        const body = {
            role: role,
            adminUser: adminUser,
            secAttrKeys: secAttrKeys,
            uncheckedAncestors: uncheckedAncestors
        };
        return this.sxHttp
            .put(`${this.roleUrl}/`, body)
            .map(response => response.json().data);
    }

    enaleRole(role: Role, adminUser: String): Observable<any> {
        const body = {
            role: role,
            adminUser: adminUser
        };
        return this.sxHttp
            .put(`${this.roleUrl}/Enable/`, body)
            .map(response => response.json().data);
    }

    disableRole(role: Role, adminUser: String): Observable<any> {
        const body = {
            role: role,
            adminUser: adminUser
        };
        return this.sxHttp
            .put(`${this.roleUrl}/Disable/`, body)
            .map(response => response.json().data);
    }

    getUsersByRole(systemCode: string, businessCode: string, roleCode: string): Promise<UsersByRolesResponse> {
        if ((systemCode === '*' && businessCode === '*'))
        {
            systemCode = 'null';
            businessCode = 'null';
        }
      const url = `${this.roleUrl}/GetUsers/${systemCode}/${businessCode}/${roleCode}`;
      return this.sxHttp.get(url)
        .map(response => response.json().data as UsersByRolesResponse)
        .toPromise();
    }

    updateUsersByRole(systemCode: string, businessCode: string, req: UsersByRoleRequest): Promise<any> {
        if ((systemCode === '*' && businessCode === '*'))
        {
            systemCode = 'null';
            businessCode = 'null';
        }
        const url = `${this.roleUrl}/UsersByRole/${systemCode}/${businessCode}`;

        return this.sxHttp
            .post(url, req)
            .map(response => response.json().data)
            .toPromise();
    }

    getSOCRole(roleCode: string): Promise<ActionConfig> {
        let url = `${this.socRoleUrl}/GetRoleActions/`;

        if (roleCode != null) {
            url = `${url}/${roleCode}`;
        }

        return this.sxHttp
            .get(url)
            .map(response => response.json().data)
            .toPromise();
    }

    createSOCRole(role: SOCRole): Promise<void> {
        const url = `${this.socRoleUrl}/CreateRole/`;

        return this.sxHttp
            .post(url, role)
            .map(response => response.json().data)
            .toPromise();
    }

    editSOCRole(role: SOCRole): Promise<void> {
        const url = `${this.socRoleUrl}/UpdateRole/`;

        return this.sxHttp
            .put(url, role)
            .map(response => response.json().data)
            .toPromise();
    }

    getAllSOCRoles(): Observable<SOCRole[]> {
        const url = `${this.socRoleUrl}/GetRoles/`;

        return this.sxHttp
            .get(url)
            .map(response => response.json().data);
    }

    setSOCRoleStatus(role: SOCRole): Promise<void> {
        const url = `${this.socRoleUrl}/SetRoleStatus`;

        return this.sxHttp
            .put(url, role)
            .map(response => response.json().data)
            .toPromise();
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/roles.service.ts